'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LinearProgress = require('./LinearProgress');

var _LinearProgress2 = _interopRequireDefault(_LinearProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LinearProgress2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/LinearProgress/index.js
 ** module id = 545
 ** module chunks = 0
 **/